








































































import Vue from 'vue';

import Task from '@/models/soukai/Task';

import AsyncOperation from '@/utils/AsyncOperation';

export default Vue.extend({
    props: {
        task: {
            type: Object as () => Task,
            required: true,
        },
    },
    computed: {
        renderedName(): string {
            const html = this.$options.filters!.markdown(this.task.name);

            // Strip surrounding p tag
            return html.substring(3, html.length - 5);
        },
        renderedDueAt(): string {
            return this.$dayjs(this.task.dueAt).calendar(undefined, {
                sameDay: '[Today]',
                nextDay: '[Tomorrow]',
                nextWeek: 'dddd',
                lastDay: '[Yesterday]',
                lastWeek: '[Last] dddd',
                sameElse: 'DD/MM/YYYY',
            });
        },
    },
    methods: {
        focus({ target }: Event) {
            if (this.task.saving)
                return;

            if (target instanceof HTMLAnchorElement && target.getAttribute('target') === '_blank')
                return;

            this.$tasks.setActive(this.task);
        },
        async toggleCompleted() {
            // Allow the checkbox to be displayed as checked before the animation starts
            await this.$nextTick();

            await this.$ui.updateModel(
                this.task,
                task => task.toggleCompleted(),
                ['priority'],
            );
        },
        async toggleStarred() {
            await this.$ui.updateModel(
                this.task,
                task => task.toggleStarred(),
                ['priority'],
            );
        },
    },
});
